import React from "react";
import styles from "./Header.module.css";
import NavBar from "../NavBar/NavBar";
import PublicNavBar from "../PublicNavBar/PublicNavBar";

type HeaderProps = {
    variant: "private" | "public";
};

const Header: React.FC<HeaderProps> = ({ variant }) => {
    return (
        <header className={styles.header}>
            {variant === "private" ? <NavBar /> : <PublicNavBar />}
        </header>
    );
};

export default Header;
